{
  "name": "Meadowlark Land Trust",
  "lang": "English",
  "ui": {
    "home": "Home",
    "about": "About",
    "services": "Conservation",
    "contact": "Contact",
    "our_services": "Conservation \u0026 Stewardship",
    "learn_more": "Learn More",
    "form_success": "Thank you for your message.",
    "form_error": "Sorry, your message could not be sent. Please try again.",
    "done_message": "Your website has been created. Feel free to describe any changes you would like to make.",
    "skip_to_content": "Skip to main content",
    "menu": "Menu",
    "yes": "Yes",
    "no": "No"
  },
  "formUrl": "https://readdy.ai/api/form/dbcboh0oojagos9kbj1g",
  "theme": {
    "accent": "forest",
    "mode": "light",
    "style": "editorial"
  },
  "nap": {
    "name": "Meadowlark Land Trust",
    "address": "10674 Vista Lane, Moreno Valley, CA 92557, United States",
    "generated": {}
  },
  "pages": [
    {
      "kind": "home",
      "path": "/",
      "title": "Meadowlark Land Trust — Land Conservation in Moreno Valley",
      "description": "Meadowlark Land Trust is a California nonprofit dedicated to long-term land preservation, responsible stewardship, and the enduring value of land in Moreno Valley.",
      "keywords": "Meadowlark Land Trust, land conservation, Moreno Valley, California land trust, stewardship, open space preservation",
      "types": [
        "navbar",
        "hero",
        "contact",
        "features",
        "showcase",
        "cases",
        "textblock",
        "team",
        "faq",
        "cta",
        "footer",
        "stickybar"
      ],
      "sections": {
        "cases": {
          "items": [
            {
              "metric": "First step",
              "metricLabel": "Listen before acting",
              "summary": "Conversations about land begin with listening — understanding a property, its surroundings, and what long-term care would require.",
              "tag": "Stewardship",
              "title": "A Thoughtful Starting Point"
            },
            {
              "metric": "3 values",
              "metricLabel": "Environment, community, future",
              "summary": "Land can hold environmental, community, and long-term conservation value at once. We aim to reflect that balance in our work and communications.",
              "tag": "Community",
              "title": "Land as Shared Value"
            }
          ],
          "subtitle": "Illustrative examples of a conservation-minded approach.",
          "title": "How We Work"
        },
        "contact": {
          "fields": [
            {
              "label": "Your name",
              "placeholder": "Jane Doe"
            },
            {
              "label": "Email address",
              "placeholder": "you@example.com",
              "type": "email"
            },
            {
              "label": "Your message",
              "placeholder": "How can we help?",
              "type": "textarea"
            }
          ],
          "note": "Prefer email? Write to hello@meadowlarklandtrust.org. Mailing address: Anthony E Metcalf, 10674 Vista Ln, Moreno Valley, CA 92557.",
          "submit": "Send Message",
          "subtitle": "For general inquiries about Meadowlark Land Trust, please contact us by email or mail.",
          "title": "Contact Meadowlark Land Trust"
        },
        "cta": {
          "button": "Send an Email",
          "subtitle": "For general inquiries about Meadowlark Land Trust, please contact us by email or mail.",
          "title": "Let's Talk About the Land"
        },
        "faq": {
          "items": [
            {
              "answer": "We focus on the importance of land preservation and responsible stewardship, and on maintaining the natural character of the places we call home.",
              "question": "What does Meadowlark Land Trust do?"
            },
            {
              "answer": "We are based in Moreno Valley, California, and serve California residents, landowners, and community members.",
              "question": "Where is Meadowlark Land Trust based?"
            },
            {
              "answer": "We speak generally about conservation principles and make no claims about specific legal protections or protected acreage.",
              "question": "Does Meadowlark Land Trust hold conservation easements?"
            },
            {
              "answer": "Please email hello@meadowlarklandtrust.org or write to us at 10674 Vista Ln, Moreno Valley, CA 92557, United States.",
              "question": "How do I get in touch?"
            },
            {
              "answer": "We do not offer public access programs. Please contact us by email for any general inquiry.",
              "question": "Can I visit or tour a property?"
            }
          ],
          "title": "Frequently Asked Questions"
        },
        "features": {
          "items": [
            {
              "description": "Preserving land can help maintain open space and protect the long-term character of natural landscapes.",
              "icon": "🌿",
              "title": "Land Preservation"
            },
            {
              "description": "Thoughtful care, respect for the environment, and consideration of future generations.",
              "icon": "🤝",
              "title": "Responsible Stewardship"
            },
            {
              "description": "Conservation is a long-term responsibility requiring care, accountability, and enduring value.",
              "icon": "🌾",
              "title": "A Lasting Commitment"
            }
          ],
          "layout": "cards",
          "subtitle": "Three principles guide how we think about conservation in our region.",
          "title": "A Long-Term Perspective on Land"
        },
        "footer": {
          "areas": [
            "Moreno Valley, California"
          ],
          "email": "hello@meadowlarklandtrust.org",
          "brand": "Meadowlark Land Trust",
          "links": [
            {
              "href": "/",
              "label": "Home"
            },
            {
              "href": "/about",
              "label": "About"
            },
            {
              "href": "#features",
              "label": "Conservation"
            },
            {
              "href": "#contact",
              "label": "Contact"
            }
          ],
          "tagline": "Land Conservation \u0026 Stewardship"
        },
        "hero": {
          "eyebrow": "Moreno Valley, California",
          "primaryCta": "Contact Us",
          "secondaryCta": "Learn About Our Mission",
          "subtitle": "Meadowlark Land Trust is dedicated to the long-term preservation of land and the natural places that make our communities unique.",
          "title": "Protecting the Land. Preserving What Matters."
        },
        "navbar": {
          "brand": "Meadowlark Land Trust",
          "cta": "Get in Touch",
          "links": [
            {
              "href": "/",
              "label": "Home"
            },
            {
              "href": "/about",
              "label": "About"
            },
            {
              "href": "#features",
              "label": "Conservation"
            },
            {
              "href": "#contact",
              "label": "Contact"
            }
          ]
        },
        "showcase": {
          "items": [
            {
              "description": "California's rolling hills and oak-studded valleys give our communities their character. Keeping land open is a quiet act of foresight.",
              "icon": "🏞️",
              "points": [
                "Protecting natural character",
                "Room for native habitat",
                "Landscape left intact"
              ],
              "title": "Open Space That Stays Open"
            },
            {
              "description": "Stewardship means respecting the environment and planning beyond a single generation — the land's value is measured in decades, not seasons.",
              "icon": "🌳",
              "points": [
                "Respect for the environment",
                "Accountability in our work",
                "Future generations first"
              ],
              "title": "Care That Outlasts Us"
            }
          ],
          "subtitle": "What careful, patient land conservation asks of us.",
          "title": "Conservation \u0026 Stewardship"
        },
        "stickybar": {
          "button": "Send an Email"
        },
        "team": {
          "items": [
            {
              "name": "Tony Metcalf",
              "bio": "Leads Meadowlark Land Trust with a focus on preservation, stewardship, and the enduring value of land.",
              "role": "President"
            },
            {
              "name": "Ruth Greyraven",
              "bio": "Encourages thoughtful care for natural landscapes and respect for the environment.",
              "role": "Vice President"
            },
            {
              "name": "Deb Bennett",
              "bio": "Responds to general inquiries from California residents, landowners, and neighbors.",
              "role": "Treasurer"
            }
          ],
          "subtitle": "A small conservation organization with a long-term view.",
          "title": "Who We Are"
        },
        "textblock": {
          "body": "Meadowlark Land Trust is a land conservation organization based in Moreno Valley, California. Our focus is on the enduring importance of land preservation and responsible stewardship. We recognize that land represents more than a physical asset: it can hold environmental, community, and long-term conservation value. Land conservation is an investment in the future, and we aim to reflect a thoughtful, conservation-minded approach in our work and communications. Based in Moreno Valley, California.",
          "title": "A Commitment to the Value of Land"
        }
      },
      "images": {
        "hero": {
          "src": "https://static.readdy.ai/image/7b095d95fe974d6d04490d0833e89a3e/5adea102fd2640276c53ce0f348ac272.png",
          "alt": "Warm sunset light filtering through a California redwood forest with ferns and a quiet trail"
        },
        "showcase": {
          "src": "https://static.readdy.ai/image/7b095d95fe974d6d04490d0833e89a3e/7f7fa2ba26ac3aae0751a80b29dfeeb8.png",
          "alt": "Pine forest with a granite mountain dome rising behind the trees under a clear blue California sky"
        },
        "showcase2": {
          "src": "https://static.readdy.ai/image/7b095d95fe974d6d04490d0833e89a3e/6a3badd3a28a13b7f0f08b30726043af.png",
          "alt": "Green California hillside with cactus and shrubs under a bright blue sky with billowing clouds"
        },
        "textblock": {
          "src": "https://static.readdy.ai/image/7b095d95fe974d6d04490d0833e89a3e/c98fc5622c7754959bc5412e0fe5155f.png",
          "alt": "Volunteers in gloves planting native grass plugs in trays on a sunny California meadow"
        }
      }
    },
    {
      "kind": "about",
      "path": "/about",
      "name": "About",
      "title": "About Meadowlark Land Trust | Moreno Valley, CA",
      "description": "Learn about Meadowlark Land Trust in Moreno Valley, CA: our mission, leadership, and commitment to land preservation and responsible stewardship.",
      "keywords": "about Meadowlark Land Trust, Moreno Valley nonprofit, land trust leadership, California stewardship",
      "types": [
        "navbar",
        "hero",
        "textblock",
        "principles",
        "leadership",
        "orgLocation",
        "footer"
      ],
      "sections": {
        "navbar": {
          "brand": "Meadowlark Land Trust",
          "cta": "Get in Touch",
          "links": [
            {
              "href": "/",
              "label": "Home"
            },
            {
              "href": "/about",
              "label": "About"
            },
            {
              "href": "/#features",
              "label": "Conservation"
            },
            {
              "href": "/#contact",
              "label": "Contact"
            }
          ]
        },
        "hero": {
          "title": "About Meadowlark Land Trust",
          "subtitle": "Dedicated to the enduring value of land and responsible stewardship."
        },
        "textblock": {
          "title": "Our Mission",
          "body": "Meadowlark Land Trust is a land conservation organization based in Moreno Valley, California.\n\nOur organization recognizes the importance of preserving land and maintaining the natural character of the places that make our communities unique. We believe that responsible stewardship and a long-term perspective are essential to the future of land conservation.\n\nThrough our commitment to the principles of preservation and stewardship, we aim to support a thoughtful approach to the lasting value of land."
        },
        "principles": {
          "title": "Principles That Guide Us",
          "items": [
            {
              "icon": "leaf",
              "title": "Land Preservation",
              "description": "We recognize the importance of protecting land and maintaining its value for future generations."
            },
            {
              "icon": "hands",
              "title": "Responsible Stewardship",
              "description": "We believe land deserves thoughtful consideration, responsible care, and a long-term perspective."
            },
            {
              "icon": "clock",
              "title": "Long-Term Commitment",
              "description": "Conservation is a responsibility that extends beyond the present, requiring an appreciation for the lasting significance of land."
            }
          ]
        },
        "leadership": {
          "title": "Our Leadership",
          "subtitle": "Meadowlark Land Trust is represented by individuals serving in leadership and financial oversight roles. Their listed positions reflect the organization's leadership structure.",
          "items": [
            {
              "name": "Tony Metcalf",
              "role": "President",
              "bio": "Tony Metcalf serves as President of Meadowlark Land Trust."
            },
            {
              "name": "Ruth Greyraven",
              "role": "Vice President",
              "bio": "Ruth Greyraven serves as Vice President of Meadowlark Land Trust."
            },
            {
              "name": "Deb Bennett",
              "role": "Treasurer",
              "bio": "Deb Bennett serves as Treasurer of Meadowlark Land Trust."
            }
          ]
        },
        "orgLocation": {
          "title": "Based in California",
          "subtitle": "Meadowlark Land Trust is based in Moreno Valley, California.",
          "address": "10674 Vista Lane\nMoreno Valley, CA 92557\nUnited States",
          "email": "hello@meadowlarklandtrust.org",
          "contactLabel": "Contact Meadowlark Land Trust",
          "contactHref": "/#contact"
        },
        "footer": {
          "brand": "Meadowlark Land Trust",
          "tagline": "Land Conservation \u0026 Stewardship",
          "email": "hello@meadowlarklandtrust.org",
          "areas": [],
          "links": [
            {
              "href": "/",
              "label": "Home"
            },
            {
              "href": "/about",
              "label": "About"
            },
            {
              "href": "/#features",
              "label": "Conservation"
            },
            {
              "href": "/#contact",
              "label": "Contact"
            }
          ]
        }
      }
    }
  ]
}
